import { NavMarker } from 'react-rhumb';
import { Flex } from 'foundations-components/components/Flex';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { View } from 'foundations-components/transitional/components/View';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import ApiError from '../../../components/Errors/ApiError';
import DeprecatedError from '../../../components/Errors/DeprecatedError';
import { EmbeddedVideo } from '../../video';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const OVERVIEW_MAX_CONTENT_WIDTH = 1180;
export const OverviewContent = ({
  deprecated,
  deprecationCta,
  loading,
  error,
  fallbackThumbnailUrl,
  children,
  headerIcons,
  allowFullWidthChildren = false,
  lessonId,
  trackId,
  shortId,
  assetLanguage,
  onVideoProgress,
  autoplay = true
}) => {
  const {
    isMobile
  } = useMediaQuery();
  return /*#__PURE__*/_jsx(Flex, {
    alignSelf: loading ? 'center' : 'normal',
    backgroundColor: "fill-surface-raised",
    flexDirection: "column",
    maxInlineSize: "100%",
    minBlockSize: "100%",
    position: "relative",
    children: loading ? /*#__PURE__*/_jsx(LoadingSpinner, {
      flex: 1,
      grow: true,
      inlineSize: !allowFullWidthChildren ? `${OVERVIEW_MAX_CONTENT_WIDTH}px` : undefined,
      maxBlockSize: "660px",
      maxInlineSize: allowFullWidthChildren ? '100%' : undefined,
      size: "medium"
    }) : deprecated ? /*#__PURE__*/_jsx(View, {
      inlineSize: !allowFullWidthChildren ? `${OVERVIEW_MAX_CONTENT_WIDTH}px` : undefined,
      maxInlineSize: allowFullWidthChildren ? '100%' : undefined,
      children: /*#__PURE__*/_jsx(DeprecatedError, {
        deprecationCta: deprecationCta
      })
    }) : error ? /*#__PURE__*/_jsx(View, {
      inlineSize: !allowFullWidthChildren ? `${OVERVIEW_MAX_CONTENT_WIDTH}px` : undefined,
      maxInlineSize: allowFullWidthChildren ? '100%' : undefined,
      children: /*#__PURE__*/_jsx(ApiError, {
        error: error.networkError,
        marker404: "OVERVIEW_MODAL_API_404",
        markerDefault: "OVERVIEW_MODAL_API_ERROR",
        showLink: false
      })
    }) : /*#__PURE__*/_jsx(NavMarker, {
      name: "OVERVIEW_MODAL_LOADED",
      children: /*#__PURE__*/_jsxs(View, {
        "data-test-id": "overview-modal-content",
        inlineSize: !allowFullWidthChildren ? `${OVERVIEW_MAX_CONTENT_WIDTH}px` : undefined,
        marginBlock: "0",
        marginInline: "auto",
        maxInlineSize: allowFullWidthChildren ? '100%' : undefined,
        overflowX: allowFullWidthChildren ? 'visible' : 'hidden',
        position: "relative",
        children: [/*#__PURE__*/_jsx(EmbeddedVideo, {
          autoPlay: autoplay,
          fallbackThumbnailUrl: fallbackThumbnailUrl,
          language: assetLanguage,
          lessonId: lessonId,
          mutedByDefault: true,
          onPlay: onVideoProgress,
          renderContext: "academy",
          shortId: shortId,
          subtitleLanguage: assetLanguage.toLowerCase(),
          trackId: trackId
        }), /*#__PURE__*/_jsx(View, {
          insetBlockStart: "24px",
          insetInlineEnd: isMobile ? '68px' : '26px',
          position: "absolute",
          children: headerIcons
        }), children]
      })
    })
  });
};
export default OverviewContent;